import { Icon, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'

interface DeliveryStatusIndicatorProps {
  label: string
}

export const DeliveryStatusIndicator = ({ label }: DeliveryStatusIndicatorProps): ReactElement => (
  <Tooltip label={label} placement="top">
    <Icon aria-label={label} icon="paperPlane" role="img" size="sm" />
  </Tooltip>
)
